import { render, staticRenderFns } from "./RecentSpots.vue?vue&type=template&id=d75eb06e"
import script from "./RecentSpots.vue?vue&type=script&lang=js"
export * from "./RecentSpots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports